import { apiClient } from "./api";
import {
  KeyAuditOperation,
  WebhookKey,
  WebhookKeyStatus,
  WebhookKeyWithPlain,
} from "../types";

interface ApiOk<T> {
  ok: true;
  data: T;
}

export interface WebhookKeyListFilters {
  partnerId?: string;
  status?: WebhookKeyStatus;
}

export interface WebhookKeyCreateBody {
  partnerId: string;
  partnerName: string;
  scopes?: string[];
  allowedEventTypes?: string[];
  notes?: string;
}

export interface WebhookKeyUpdateBody {
  partnerName?: string;
  status?: "active" | "disabled";
  scopes?: string[];
  allowedEventTypes?: string[];
  notes?: string;
}

export interface WebhookKeyRotateBody {
  disablePrevious?: boolean;
  notes?: string;
}

export const webhookKeyService = {
  list: (filters?: WebhookKeyListFilters) =>
    apiClient.get<ApiOk<{ keys: WebhookKey[] }>>("/v1/webhook-keys", {
      params: filters,
    }),

  getById: (keyId: string) =>
    apiClient.get<
      ApiOk<{ key: WebhookKey; auditLogs: KeyAuditOperation[] }>
    >(`/v1/webhook-keys/${keyId}`),

  create: (body: WebhookKeyCreateBody) =>
    apiClient.post<ApiOk<WebhookKeyWithPlain>>("/v1/webhook-keys", body),

  update: (keyId: string, body: WebhookKeyUpdateBody) =>
    apiClient.patch<ApiOk<WebhookKey>>(`/v1/webhook-keys/${keyId}`, body),

  revoke: (keyId: string) =>
    apiClient.post<ApiOk<WebhookKey>>(`/v1/webhook-keys/${keyId}/revoke`),

  rotate: (keyId: string, body?: WebhookKeyRotateBody) =>
    apiClient.post<ApiOk<WebhookKeyWithPlain>>(
      `/v1/webhook-keys/${keyId}/rotate`,
      body ?? {}
    ),
};
